import { NfzDepartment } from '@dreryk/egabinet-nfz-configuration-frontend-api';
import { NfzDepartmentForPatientQuery } from '@dreryk/egabinet-patient-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { AutosuggestSearchCreator } from '@dreryk/react-components';

export const getPatientNfzDepartmentLabel = (department?: NfzDepartment): string => department?.name ?? '';

export const nfzDepartmentsSearchCreator: AutosuggestSearchCreator<NfzDepartment> = () => {
   return async (): CqrsQueryPerformResult<NfzDepartment[]> =>
      performCqrsQuerySearch(() => new NfzDepartmentForPatientQuery());
};
